import { MetamaskError } from "shared/dist/utils/error";
import { initSDK } from "shared/dist/utils/snetSdk";

export const blockChainEvents = {
    TRANSACTION_HASH: "transactionHash",
    RECEIPT: "receipt",
    CONFIRMATION: "confirmation",
    ERROR: "error",
};

export const checkIsOwnerAddress = async (ownerAddress) => {
    if (!ownerAddress) {
        console.error("Owner address is required");
    }

    try {
        const sdk = await initSDK();
        const currentAddress = await sdk.account.getAddress();

        if (!currentAddress) {
            throw new MetamaskError("No connected wallet address found");
        }

        const overAddressLC = ownerAddress.toLowerCase();
        const currentAddressLC = currentAddress.toLowerCase();

        if (overAddressLC !== currentAddressLC) {
            throw new MetamaskError(
                `You've connected with ${currentAddressLC}. Please switch to the owner's MetaMask account (${overAddressLC}) to proceed`
            );
        }

        return true;
    } catch (error) {
        throw new MetamaskError(`Address verification failed: ${error.message}`);
    }
};
